/**
 * frontend/src/lib/urlApi.ts
 *
 * ⚠ LOT 3 `§5` — **LE FRONT POINTE SON API PAR UNE VARIABLE DE BUILD, JAMAIS EN DUR.**
 *
 * *En production, le dashboard (`staging.sfmt.orbicore.app`) et l'API (`api.staging.sfmt.orbicore.app`)
 *  vivent sur deux sous-domaines : un chemin relatif `/api/v1/...` partirait vers le serveur du dashboard.
 *  `VITE_API_URL` est lue par Vite AU BUILD (`Dockerfile.web`, `ARG`).*
 *
 * *Vide — en développement et en test —, rien ne change : les chemins restent relatifs et le proxy
 *  Vite (`/api`, `/uploads`, `/flashinfo-photos`) les sert comme avant.*
 */
const BASE = String(import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

/** Adresse d'un appel à l'API. `chemin` commence par `/` (ex. `/api/v1/auth/refresh`). */
export function urlApi(chemin: string): string {
  return `${BASE}${chemin}`;
}

/**
 * Adresse d'un fichier SERVI PAR L'API (photos SKU, photos Flash Info) : le serveur rend des chemins
 * relatifs (`/flashinfo-photos/...`, `/uploads/sku-photos/...`). Une adresse déjà absolue, `data:` ou
 * `blob:` (aperçu local avant envoi) passe telle quelle.
 */
export function urlMedia(chemin: string | null | undefined): string | undefined {
  if (!chemin) return undefined;
  if (/^(https?:|data:|blob:)/i.test(chemin)) return chemin;
  return chemin.startsWith('/') ? `${BASE}${chemin}` : chemin;
}
